import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { EmployeeState } from './employee.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  protected url = '/hrm-portal-api/api/employees';

  /**
   * Constructor
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  fetchCurrentEmployeeInfo(): Observable<EmployeeState> {
    return this._http.get<EmployeeState>(this.url + '/my-info');
  }
}
